<template>
  <el-card class="h-full flex flex-col" :body-style="{ padding: '20px', height: '100%' }">
    <el-page-header :content="title" @back="back"> </el-page-header>
    <el-collapse
      v-model="activeName"
      class="mt-20px overflow-auto border"
      style="height: calc(100% - 108px)"
    >
      <el-collapse-item title="指标信息" name="1">
        <el-form label-width="150px" :model="formData" ref="form" :rules="rules">
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="指标名称" prop="name">
                <el-input placeholder="请输入" v-model="formData.name" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="指标编码" prop="code">
                <el-input
                  placeholder="请输入"
                  v-model="formData.code"
                  clearable
                  :disabled="type === 'update'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="数据模型" prop="dataModelId">
                <el-select
                  placeholder="请选择"
                  v-model="formData.dataModelId"
                  clearable
                  filterable
                  class="!w-full"
                  @change="changeModelId"
                >
                  <el-option
                    v-for="(item, index) in dataModelList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="指标域" prop="metricsDmainId">
                <el-select
                  placeholder="请选择"
                  v-model="formData.metricsDmainId"
                  clearable
                  filterable
                  :filter-method="searchMetricsDmain"
                  class="!w-full"
                  popper-class="tag_select-popper"
                  ref="selectMetrics"
                  @clear="clearMetricsDmainId"
                >
                  <el-option :label="metricsDmainName" :value="formData.metricsDmainId">
                    <el-tree
                      :data="treeData"
                      :props="{
                        children: 'child',
                        label: 'name',
                      }"
                      node-key="id"
                      :current-node-key="currentNodeKey"
                      ref="tree"
                      @node-click="handleNodeClick"
                      default-expand-all
                    >
                    </el-tree> </el-option
                ></el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="选择度量字段" name="2">
        <el-table
          :data="measureData"
          width="100%"
          height="200"
          border
          stripe
          @selection-change="selectMeasure"
          ref="measureTable"
          row-key="id"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
          <el-table-column show-overflow-tooltip label="属性名称" prop="code"></el-table-column>
          <el-table-column show-overflow-tooltip label="属性代码" prop="name"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="字段类型"
            prop="sourceFieldTypeStr"
          ></el-table-column>
        </el-table>
        <div class="flex justify-end mt-20px">
          <el-pagination
            background
            @size-change="measureSizeChange"
            @current-change="measureCurrentChange"
            :current-page.sync="measurePage.pageNo"
            layout="total, sizes, prev, pager, next"
            :page-size.sync="measurePage.pageSize"
            :total="measurePage.total"
            :page-sizes="$pageSizeAll"
            :pager-count="5"
          >
          </el-pagination>
        </div>
      </el-collapse-item>
      <el-collapse-item title="选择维度字段" name="3">
        <el-table
          :data="dimensionData"
          width="100%"
          height="200"
          border
          stripe
          @selection-change="selectDimension"
          ref="dimensionTable"
          row-key="id"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
          <el-table-column show-overflow-tooltip label="属性名称" prop="code"></el-table-column>
          <el-table-column show-overflow-tooltip label="属性代码" prop="name"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="字段类型"
            prop="sourceFieldTypeStr"
          ></el-table-column>
        </el-table>
        <div class="flex justify-end mt-20px">
          <el-pagination
            background
            @size-change="dimensionSizeChange"
            @current-change="dimensionCurrentChange"
            :current-page.sync="dimensionPage.pageNo"
            layout="total, sizes, prev, pager, next"
            :page-size.sync="dimensionPage.pageSize"
            :total="dimensionPage.total"
            :page-sizes="$pageSizeAll"
            :pager-count="5"
          >
          </el-pagination>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mt-20px text-center">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="back">取消</el-button>
    </div>

    <!-- 编辑的提示弹窗 -->
    <el-dialog
      title="提示！"
      :visible.sync="visiable"
      class="small-dialog"
      v-dialogDrag
      :close-on-click-modal="false"
    >
      <div class="text-16px">编辑后会导致已发布的指标数据无法展示及关联指标无法引用！</div>
      <div class="text-16px mt-10px">关联指标如下：</div>
      <div class="mt-10px overflow-auto">
        <div class="mt-5px text-color" v-for="(value, key, index) in errMsg" :key="index">
          <span>【{{ value.asName }}】</span>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="visiable = false">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import DataModelService from '@/services/DataModelService'
import MetricsManagementService from '@/services/MetricsManagementService'

export default {
  name: 'AtomicIndicators',
  data() {
    return {
      activeName: ['1', '2', '3'],
      formData: {
        name: '',
        code: '',
        dataModelId: '',
        metricsDmainId: '',
        type: 0, // 原子指标
      },
      rules: {
        name: [{ required: true, message: '请输入指标名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入指标编码', trigger: 'blur' }],
        dataModelId: [{ required: true, message: '请选择数据模型', trigger: 'change' }],
        metricsDmainId: [{ required: true, message: '请选择指标域', trigger: 'change' }],
      },
      measureData: [], // 度量数据
      measurePage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      dimensionData: [], // 维度数据
      dimensionPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      dataModelList: [],
      allMeasureData: [], // 所有度量数据
      allDimensionData: [], // 所有维度数据
      selectMeasureList: [], // 选择的度量数据
      selectDimensionList: [], // 选择的维度字段
      metricsDmainName: '', // 指标域名称
      treeData: [],
      currentNodeKey: '',
      type: '', // 操作类型
      id: '', // 详情id
      title: '',
      visiable: false,
      errMsg: {},
    }
  },
  methods: {
    back() {
      this.$router.push(`./metrics-management?metricsDmainId=${this.formData.metricsDmainId}`)
    },
    // 获取数据模型(只能依赖已发布的数据模型)
    async getDataModel() {
      const res = await DataModelService.getList({
        NameOrCode: '',
        Sorting: '',
        SkipCount: 0,
        MaxResultCount: 999,
      })
      if (res && res.code === 0 && res.data) {
        this.dataModelList = _.filter(res.data, (item) => {
          return item.isPublish
        })
      }
    },
    // 修改数据模型
    changeModelId(val) {
      if (val) this.queryDimensionList(val, '')
    },
    // 查询维度列表
    async queryDimensionList(dataModelId, type) {
      const res = await MetricsManagementService.queryDimensionList({
        sorting: '',
        skipCount: 0,
        maxResultCount: 999,
        dataModelId,
        type,
      })
      if (res && res.code === 0 && res.data) {
        this.allMeasureData = _.filter(res.data, (item) => {
          return item.type === 1
        })
        this.getMeasureData()
        this.measurePage.total = this.allMeasureData.length
        this.allDimensionData = _.filter(res.data, (item) => {
          return item.type !== 1
        })
        this.getDimensionData()
        this.dimensionPage.total = this.allDimensionData.length
      }
    },
    // 获取度量分页数据
    getMeasureData() {
      this.measureData = this.allMeasureData.slice(
        (this.measurePage.pageNo - 1) * this.measurePage.pageSize,
        this.measurePage.pageNo * this.measurePage.pageSize
      )
    },
    // 获取维度分页数据
    getDimensionData() {
      this.dimensionData = this.allDimensionData.slice(
        (this.dimensionPage.pageNo - 1) * this.dimensionPage.pageSize,
        this.dimensionPage.pageNo * this.dimensionPage.pageSize
      )
    },
    measureCurrentChange(num) {
      this.measurePage.pageNo = num
      this.getMeasureData()
    },
    measureSizeChange(pageSize) {
      this.measurePage.pageSize = pageSize
      this.getMeasureData()
    },
    dimensionCurrentChange(num) {
      this.dimensionPage.pageNo = num
      this.getDimensionData()
    },
    dimensionSizeChange(pageSize) {
      this.dimensionPage.pageSize = pageSize
      this.getDimensionData()
    },
    // 选择度量字段(单选)
    selectMeasure(val) {
      this.selectMeasureList = val
    },
    // 选择维度字段（多选）
    selectDimension(val) {
      this.selectDimensionList = val
    },
    // 保存
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // if (this.selectMeasureList.length === 0) {
          //   this.$message.warning('请选择度量字段')
          //   return
          // }
          if (this.selectMeasureList.length > 1) {
            this.$message.warning('只能选择一个度量字段')
            return
          }
          if (this.selectDimensionList.length === 0) {
            this.$message.warning('请选择维度字段')
            return
          }
          let dimensionsList = this.selectMeasureList.concat(this.selectDimensionList)
          dimensionsList = _.map(dimensionsList, (item) => {
            return {
              dataModelDimensionId: item.id,
              isReference: false,
              asName: item.name,
              asCode: item.code,
            }
          })
          if (this.type === 'update') {
            this.updateMetrics(dimensionsList)
          } else {
            this.addMetrics(dimensionsList)
          }
        }
      })
    },
    // 新增指标
    async addMetrics(dimensionsList) {
      const res = await MetricsManagementService.addMetrics({
        name: this.formData.name,
        code: this.formData.code,
        dataModelId: this.formData.dataModelId,
        metricsDmainId: this.formData.metricsDmainId,
        type: 0,
        dimensions: dimensionsList,
        createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
      })
      if (res && res.code === 0) {
        this.$message.success('原子指标新增成功')
        this.back()
      }
    },
    // 编辑指标
    async updateMetrics(dimensionsList) {
      const res = await MetricsManagementService.updateMetrics({
        id: this.id,
        name: this.formData.name,
        code: this.formData.code,
        dataModelId: this.formData.dataModelId,
        metricsDmainId: this.formData.metricsDmainId,
        type: 0,
        dimensions: dimensionsList,
        createdUserName: Wiz.AuthHooks.GetUserInfo().profile.name,
      })
      if (res && res.code === 0) {
        if (res.details) {
          this.visiable = true
          this.errMsg = res.details
        } else {
          this.$message.success('原子指标修改成功')
          this.back()
        }
      }
    },
    handleNodeClick(node) {
      this.formData.metricsDmainId = node.id
      this.metricsDmainName = node.name
      this.$refs.selectMetrics.handleClose()
    },
    clearMetricsDmainId() {
      this.formData.metricsDmainId = ''
      this.metricsDmainName = ''
    },
    // 根据关键字查询指标域
    async searchMetricsDmain(val) {
      const res = await MetricsManagementService.searchMetricsDmain({
        nameOrCode: val || '',
      })
      if (res && res.code === 0 && res.data) {
        this.treeData = res.data
        this.currentNodeKey = this.formData.metricsDmainId
        this.accordIdToName(this.treeData, this.currentNodeKey)
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentNodeKey)
        })
      }
    },
    // 根据指标域id查找name
    accordIdToName(data, id) {
      _.map(data, (item) => {
        if (item.id === id) {
          this.metricsDmainName = item.name
        } else if (item.id !== id && item.child && item.child.length > 0) {
          this.accordIdToName(item.child, id)
        }
      })
    },
    // 查询指标详情
    async getMetrics() {
      if (!this.id) return
      const res = await MetricsManagementService.getMetrics(this.id)
      if (res && res.code === 0 && res.data) {
        if (this.type === 'update') {
          _.assign(
            this.formData,
            _.pick(res.data, ['name', 'code', 'dataModelId', 'metricsDmainId', 'type'])
          )
        } else if (this.type === 'copy') {
          _.assign(this.formData, _.pick(res.data, ['dataModelId', 'metricsDmainId', 'type']))
        }
        await this.queryDimensionList(this.formData.dataModelId, '')
        // 度量字段
        _.map(this.allMeasureData, (item) => {
          if (_.find(res.data.dimensions, ['dataModelDimensionId', item.id])) {
            this.selectMeasureList.push(item)
          }
        })
        _.map(this.selectMeasureList, (item) => {
          this.$nextTick(() => {
            this.$refs.measureTable.toggleRowSelection(item, true)
          })
        })
        // 维度字段
        _.map(this.allDimensionData, (item) => {
          if (_.find(res.data.dimensions, ['dataModelDimensionId', item.id])) {
            this.selectDimensionList.push(item)
          }
        })
        _.map(this.selectDimensionList, (item) => {
          this.$nextTick(() => {
            this.$refs.dimensionTable.toggleRowSelection(item, true)
          })
        })
      }
    },
  },
  async created() {
    this.type = this.$route.query.type
    if (this.type === 'add') {
      this.title = '新增原子指标'
      this.formData.metricsDmainId = this.$route.query.metricsDmainId
        ? this.$route.query.metricsDmainId
        : ''
      this.metricsDmainName = this.$route.query.metricsDmainName
        ? this.$route.query.metricsDmainName
        : ''
    } else if (this.type === 'update') {
      this.title = '编辑原子指标'
      this.id = this.$route.query.id
      await this.getMetrics()
    } else if (this.type === 'copy') {
      this.title = '复制原子指标'
      this.id = this.$route.query.id
      await this.getMetrics()
    }
    this.getDataModel()
    this.searchMetricsDmain()
  },
}
</script>

<style lang="scss">

.el-popper.tag_select-popper .el-select-dropdown__item {
  height: 100% !important;
  padding: 0;
}
.text-color {
  color: var(--systemMainColor);
}

</style>
